'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* istanbul ignore next */
var root = function () {
	if (typeof window !== 'undefined') {
		// Browser window
		return window;
	}

	if (typeof self !== 'undefined') {
		// Web Worker
		return self;
	}

	if (typeof global !== 'undefined') {
		// Node
		return global;
	}

	// Other environments
	return this; // eslint-disable-line no-invalid-this
}();

var isObject = function isObject(obj) {
	return Object.prototype.toString.call(obj) === '[object Object]';
};

var _isSupported = 'Intl' in root && typeof Intl.NumberFormat === 'function' && typeof Intl.DateTimeFormat === 'function' && typeof Number.prototype.toLocaleString === 'function' && typeof Date.prototype.toLocaleDateString === 'function' && typeof Date.prototype.toLocaleTimeString === 'function';

/* istanbul ignore if */

var VI18N = function () {
	function VI18N() {
		var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'nl-NL';

		var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
		    _ref$time = _ref.time,
		    time = _ref$time === undefined ? {} : _ref$time,
		    _ref$number = _ref.number,
		    number = _ref$number === undefined ? {} : _ref$number,
		    _ref$percent = _ref.percent,
		    percent = _ref$percent === undefined ? {} : _ref$percent,
		    _ref$currency = _ref.currency,
		    currency = _ref$currency === undefined ? {} : _ref$currency;

		_classCallCheck(this, VI18N);

		// Fail fast when the Internationalization API isn't supported
		if (!VI18N.isSupported()) {
			throw new Error('Internationalization API not supported, did you forget to include a polyfill?');
		}

		this.locale = locale;
		this.formatters = {};
		this.months = {};
		this.days = {};
		this.decimalSeparator = null;
		this.thousandSeparator = null;

		this.initialize(locale, time, number, percent, currency);
	}

	_createClass(VI18N, [{
		key: 'initialize',
		value: function initialize(locale, timeOptions, numberOptions, percentOptions, currencyOptions) {
			var _timeOptions$timeZone = timeOptions.timeZone,
			    timeZone = _timeOptions$timeZone === undefined ? 'Europe/Amsterdam' : _timeOptions$timeZone,
			    _timeOptions$hour = timeOptions.hour,
			    hour = _timeOptions$hour === undefined ? '2-digit' : _timeOptions$hour,
			    _timeOptions$minute = timeOptions.minute,
			    minute = _timeOptions$minute === undefined ? '2-digit' : _timeOptions$minute,
			    _timeOptions$second = timeOptions.second,
			    second = _timeOptions$second === undefined ? '2-digit' : _timeOptions$second;


			this.formatters.number = new Intl.NumberFormat(locale, Object.assign({}, {
				minimumFractionDigits: 0,
				maximumFractionDigits: 3
			}, numberOptions));

			this.formatters.currency = new Intl.NumberFormat(locale, Object.assign({
				currency: 'EUR',
				style: 'currency'
			}, currencyOptions));

			this.formatters.percent = new Intl.NumberFormat(locale, Object.assign({ style: 'percent' }, percentOptions));
			this.formatters.date = new Intl.DateTimeFormat(locale, {
				timeZone: timeZone
			});

			var _formatters$date$reso = this.formatters.date.resolvedOptions(),
			    year = _formatters$date$reso.year,
			    month = _formatters$date$reso.month,
			    day = _formatters$date$reso.day;

			this.formatters.time = new Intl.DateTimeFormat(locale, {
				timeZone: timeZone,
				hour: hour,
				minute: minute,
				second: second
			});

			this.formatters.dateTime = new Intl.DateTimeFormat(locale, {
				timeZone: timeZone,
				year: year,
				month: month,
				day: day,
				hour: hour,
				minute: minute,
				second: second
			});
		}

		// Format a number to a locale string
		// For more information about the options see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat

	}, {
		key: 'formatNumber',
		value: function formatNumber(number) {
			return this.formatters.number.format(number);
		}

		// Format a number to a locale currency string
		// For more information about the options see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat

	}, {
		key: 'formatCurrency',
		value: function formatCurrency(number) {
			return this.formatters.currency.format(number);
		}
	}, {
		key: 'formatPercent',
		value: function formatPercent(number) {
			return this.formatters.percent.format(number);
		}

		// Format a date object to a locale string
		// For more information about the options see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat

	}, {
		key: 'formatDate',
		value: function formatDate(date, options) {
			return isObject(options) ? date.toLocaleDateString(this.locale, options) : this.formatters.date.format(date);
		}
	}, {
		key: 'formatTime',
		value: function formatTime(date) {
			return this.formatters.time.format(date);
		}
	}, {
		key: 'formatDateTime',
		value: function formatDateTime(date, options) {
			return this.formatters.dateTime.format(date);
		}

		// Assume it is always one character
		// https://en.wikipedia.org/wiki/Decimal_mark
		// TODO: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat/formatToParts#Browser_compatibility

	}, {
		key: 'getDecimalSeparator',
		value: function getDecimalSeparator() {
			return this.decimalSeparator || (this.decimalSeparator = this.formatNumber(1.1).charAt(1)); // eslint-disable-line max-len
		}
	}, {
		key: 'getThousandSeparator',
		value: function getThousandSeparator() {
			var _this = this;

			return this.thousandSeparator || (this.thousandSeparator = function () {
				var separator = _this.formatNumber(1000).charAt(1);

				// When the separator is not a number (e.g. the decimal point in '1.000')
				// return the separator, otherwise return an empty string
				return isNaN(parseInt(separator, 10)) ? separator : '';
			}());
		}
	}, {
		key: 'getMonths',
		value: function getMonths() {
			var _this2 = this;

			var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'long';

			return this.months[type] || (this.months[type] = function () {
				var date = new Date(Date.UTC(2015, 0, 1));
				var months = [];

				for (var i = 0; i < 12; i++) {
					date.setMonth(i);
					months[i] = _this2.formatDate(date, { month: type });
				}

				return months;
			}());
		}
	}, {
		key: 'getDays',
		value: function getDays() {
			var _this3 = this;

			var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'long';

			return this.days[type] || (this.days[type] = function () {
				var date = new Date(Date.UTC(1978, 0, 1)); // https://en.wikipedia.org/wiki/Common_year_starting_on_Sunday
				var days = [];

				for (var i = 1; i <= 7; i++) {
					date.setUTCDate(i);
					days.push(_this3.formatDate(date, { weekday: type }));
				}

				return days;
			}());
		}
	}], [{
		key: 'isSupported',
		value: function isSupported() {
			return _isSupported;
		}
	}]);

	return VI18N;
}();

module.exports = VI18N;